import {
    ServiceInformationProps,
    ServiceMonitoringProps,
    ServiceNotificationProps,
    ServiceReceiptProps,
    ServiceSettingProps,
} from '@/modules/Service/types'
import DomainVNNIC from './Domain/DomainVNNIC'
import ContentDeliveryNetwork from './Conversant/ContentDeliveryNetwork'
import Transcoding from './Conversant/Transcoding'
import VPS from './Cloud/VPS'
import VNIS from './Vnis'
import Hosting from './Cloud/Hosting'
import OSS from './Conversant/StorageOSS'
import Transmuxing from './Conversant/Transmuxing'
import Recording from './Conversant/Recording'
import EmailServer from './Email/EmailServer'
import StorageLFD from './Conversant/StorageLFD'
import EGPlatform from './Email/EGPlatform'
import SSL from './SSL'
import BareMetalServer from './Server/BareMetalServer'
import Colocation from './Server/Colocation'
import VCloud from './Cloud/VCloud'
import DeviceLiquidation from './DeviceLiquidation'
import OtherStandard from './OtherStandard'

const BlankTemplate = {
    Information: (props: ServiceInformationProps) => {
        // Implement your logic here
        console.log('Information', props)
        return <div className="card mt-2">Blank Template</div>
    },
    Setting: (props: ServiceSettingProps) => {
        // Implement your logic here
        console.log('Setting', props)
        return <div className="card mt-2">Blank Template Setting</div>
    },
    Notification: (props: ServiceNotificationProps) => {
        // Implement your logic here
        console.log(`Notification`, props)
        return <div className="card mt-2">Blank Template Notification</div>
    },
    Receipt: (props: ServiceReceiptProps) => {
        // Implement your logic here
        console.log(`Receipt`, props)
        return <div className="card mt-2">Blank Template Receipt</div>
    },
    Monitoring: (props: ServiceMonitoringProps) => {
        // Implement your logic here
        console.log(`Monitoring`, props)
        return <div className="card mt-2">Blank Template Monitoring</div>
    },
    Statement: (props: ServiceSettingProps) => {
        // Implement your logic here
        console.log(`Statement`, props)
        return <div className="card mt-2">Blank Template Statement</div>
    },
}

const ServiceTemplates = {
    // SwiftFederation
    'SwiftFederation.CDN': ContentDeliveryNetwork,
    'SwiftFederation.Transcoding': Transcoding,
    'SwiftFederation.Transmuxing': Transmuxing,
    'SwiftFederation.Recording': Recording,
    'SwiftFederation.StorageLFD': StorageLFD,
    'SwiftFederation.StorageOSS': OSS,
    'Mlytics.Vnis': VNIS,
    // Email
    'Email.Server': EmailServer,
    'Email.EGPlatform': EGPlatform,
    // VPS
    'Cloud.VPS': VPS,
    'Cloud.Hosting': Hosting,
    'Cloud.VCloud': VCloud,
    // Dedicate Service
    'Server.VBM': BareMetalServer,
    'Server.Dedicated': BlankTemplate,
    'Server.Colocation': Colocation,
    // Domain
    'Domain.VNNIC': DomainVNNIC,
    'Domain.TLDs': DomainVNNIC,
    // SSL
    'SSL.SSL': SSL,
    // Device Liquidation
    'Device.Liquidation': DeviceLiquidation,
    // Other
    'Other.Standard': OtherStandard,
    Blank: BlankTemplate,
}

export default ServiceTemplates
